import { DELETE_FAVOURITE_BOARD } from "./actionTypes";

export default ({boardId, objectType}) => ({
  type: DELETE_FAVOURITE_BOARD,
  payload: {
    boardId,
    objectType
  },
});